export const isNumber = (value: string) => {
    return value ? !Number.isNaN(Number(value)) : false
}

export const DEFAULT_LOCALE = Intl.NumberFormat().resolvedOptions().locale

export const formatNumber = (
    value: number | bigint | string,
    decimals: number | bigint = 0,
    locale: string = DEFAULT_LOCALE,
) => {
    const numberFormat = new Intl.NumberFormat(locale, {
        style: 'decimal',
        maximumFractionDigits: decimals ? Number(decimals) : undefined,
    })

    const valueNumber = typeof value === 'string' ? Number(value) : value
    return numberFormat.format(valueNumber)
}

export const getLocaleDecimalPlacesSeparator = (locale: string = DEFAULT_LOCALE) => {
    const numberFormat = new Intl.NumberFormat(locale, {
        style: 'decimal',
    })
    return numberFormat.format(1.1).replace('1', '').replace('1', '')
}

export const hasLowerOrEqualMaxDecimalPlaces = (
    value: string,
    maxDecimalPlaces: number | bigint,
    locale: string = DEFAULT_LOCALE,
) => {
    const decimalPlacesSeparator = getLocaleDecimalPlacesSeparator(locale)
    const decimalPlaces = value.split(decimalPlacesSeparator)[1]?.length ?? 0
    return decimalPlaces <= Number(maxDecimalPlaces)
}
